/* eslint import/no-webpack-loader-syntax: off */
import css from "!!raw-loader!./theme.css";
/* eslint import/no-webpack-loader-syntax: off */
import html from "!!raw-loader!./core.html";

const theme = {
  name: "Theme-2",
  version: "0.0.0",
  pointer: true,
  defaultCore: { html },
  css,
};
export default theme;
